import { SVGIconComponent } from './types';

export const StatusCancelled: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/status-cancelled" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12,2 C6.47685975,2 2,6.47685975 2,12 C2,17.5223371 6.47685975,22 12,22 C17.5223371,22 22,17.5223371 22,12 C22,6.47685975 17.5223371,2 12,2 Z M15.7717097,15.8108624 C15.3724927,16.2100793 14.7254493,16.2100793 14.3270154,15.8108624 L12.0517418,13.5355888 L9.67286417,15.9144664 C9.27364722,16.3136834 8.62660375,16.3136834 8.22816986,15.9144664 C7.82895292,15.5152495 7.82895292,14.868206 8.22816986,14.4689891 L10.6070475,12.0901114 L8.39220962,9.87527357 C7.99299267,9.47605662 7.99299267,8.82901315 8.39220962,8.42979621 C8.79142656,8.03057926 9.43847003,8.03057926 9.83768698,8.42979621 L12.0525248,10.6446341 L14.1639594,8.53319948 C14.5631764,8.13398253 15.2102199,8.13398253 15.6086537,8.53319948 C16.0078707,8.93241642 16.0078707,9.57945989 15.6086537,9.97867684 L13.4972192,12.0901114 L15.7724927,14.365385 C16.1709266,14.7646019 16.1709266,15.4116454 15.7717085,15.8108624 L15.7717097,15.8108624 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
